// Mens Bundle Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Mark", location: "IL", product: "#1 Men's Bundle", time: "32 minutes ago" },
    { name: "Quennel", location: "NC", product: "#1 Men's Bundle", time: "1 hour 3 minutes ago" },
    { name: "Yoangel", location: "FL", product: "#1 Men's Bundle", time: "1 hour 35 minutes ago" },
    { name: "Francisco", location: "TX", product: "#1 Men's Bundle", time: "2 hours 8 minutes ago" },
    { name: "Anthony", location: "FL", product: "#1 Men's Bundle", time: "2 hours 42 minutes ago" },
    { name: "Luis", location: "CA", product: "#1 Men's Bundle", time: "3 hours 17 minutes ago" },
    { name: "Cushing", location: "NC", product: "#1 Men's Bundle", time: "3 hours 53 minutes ago" },
    { name: "Montique", location: "WA", product: "#1 Men's Bundle", time: "4 hours 30 minutes ago" },
    { name: "Tiffini", location: "TX", product: "#1 Men's Bundle", time: "5 hours 8 minutes ago" },
    { name: "Brenda", location: "LA", product: "#1 Men's Bundle", time: "5 hours 47 minutes ago" },
    { name: "James", location: "TX", product: "#1 Men's Bundle", time: "25 minutes ago" },
    { name: "Jamie", location: "PA", product: "#1 Men's Bundle", time: "58 minutes ago" },
    { name: "Stephen", location: "CA", product: "#1 Men's Bundle", time: "1 hour 32 minutes ago" },
    { name: "Guillermo", location: "CA", product: "#1 Men's Bundle", time: "2 hours 7 minutes ago" },
    { name: "Terry", location: "KY", product: "#1 Men's Bundle", time: "2 hours 43 minutes ago" },
    { name: "Rayshawne", location: "MD", product: "#1 Men's Bundle", time: "3 hours 20 minutes ago" },
    { name: "Debbie", location: "HK", product: "#1 Men's Bundle", time: "3 hours 58 minutes ago" },
    { name: "Edgar", location: "CA", product: "#1 Men's Bundle", time: "4 hours 37 minutes ago" },
    { name: "Alejandra", location: "TX", product: "#1 Men's Bundle", time: "5 hours 17 minutes ago" },
    { name: "Javier", location: "VA", product: "#1 Men's Bundle", time: "5 hours 58 minutes ago" },
    { name: "Chris", location: "FL", product: "#1 Men's Bundle", time: "22 minutes ago" },
    { name: "Perry", location: "NM", product: "#1 Men's Bundle", time: "48 minutes ago" },
    { name: "Genaro", location: "AZ", product: "#1 Men's Bundle", time: "1 hour 15 minutes ago" },
    { name: "Sam", location: "MA", product: "#1 Men's Bundle", time: "1 hour 43 minutes ago" },
    { name: "Atam", location: "NJ", product: "#1 Men's Bundle", time: "2 hours 12 minutes ago" },
    { name: "Penny", location: "MT", product: "#1 Men's Bundle", time: "2 hours 42 minutes ago" },
    { name: "Alex", location: "SC", product: "#1 Men's Bundle", time: "3 hours 13 minutes ago" },
    { name: "Jay", location: "AL", product: "#1 Men's Bundle", time: "3 hours 45 minutes ago" },
    { name: "Vicente", location: "TX", product: "#1 Men's Bundle", time: "4 hours 18 minutes ago" },
    { name: "Douglas", location: "AZ", product: "#1 Men's Bundle", time: "4 hours 52 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/1_Mens_Bundle_No_Badge.png?v=1733788033" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
